<div class="login align-center">
  <img class="image" src="../../assets/code-heroes-logo.svg">
  <div class="title">Code Heroes</div>
  <button mat-raised-button (click)="auth.googleLogin()"><img class="signInImage" src="../../assets/google.png">Sign in
    with Google!
  </button>
</div>
